module.exports = "https://cdn.dove.it/_next/static/public/assets/properties/cantieri.221b9233e8cf38147275b6a6d0098c22.jpg";